import { ModelSagres } from "@/types/model-sagres";
import { Perfil } from "../cadastro-permissoes/perfil";
/**
 * Recebido da API de usuários NestJS
 * @since 20240830
 */
export class UsuarioPerfil extends ModelSagres {


  ug?: string;
  idUsuario?: number
  idUsuarioPerfil: number;
  idUnidadeGestora: number;
  perfil: Perfil;

  //adicionar id usuarios

  /*   {
    "PERFIL": {
        "DESCRICAO": "Visualização de Avisos"
    },
    "CRP_UNIDADEGESTORA": {
        "NM_NOME": "DEFENSORIA PUBLICA DO ESTADO DE SERGIPE"
    }
} */

  constructor(obj?: any) {
    super();
    //console.log(obj)

    if (obj) {

      if (obj?.CRP_UNIDADEGESTORA?.NM_NOME)
        this.ug = obj.CRP_UNIDADEGESTORA.NM_NOME;
      if (obj?.ID_USUARIO_PERFIL) this.idUsuarioPerfil = obj.ID_USUARIO_PERFIL;
      if (obj?.CRP_UNIDADEGESTORA?.ID) this.idUnidadeGestora = obj.CRP_UNIDADEGESTORA.ID;
      //Novo
      if (obj.PERFIL) this.perfil = new Perfil(obj.PERFIL)
      if (obj.ID_USUARIO) this.idUsuario = obj.ID_USUARIO
      //Para aba específica de usuariosporug
      if (obj.ID_UNIDADE_GESTORA) this.idUnidadeGestora = obj.ID_UNIDADE_GESTORA

    }
  }
}
